<template>
    <document-head title="Level"/>

    <app-layout>
            <div class="mt-8 flex flex-row justify-between">
                <h1 class="text-3xl font-semibold text-gray-900">{{ level.title }}</h1>
                <div class="flex flex-row">
                    <a :download="level.title+'.lvl'" :href="'data:text/plain;charset=ascii,'+encodeURIComponent(level.string)" class="bg-gray-700 text-white py-2 px-4 rounded text-sm hover:bg-gray-800" onclick="navigator.clipboard.writeText(document.getElementById('string').value);document.getElementById('confirm').classList.remove('hidden')">
                        Download Level
                    </a>
                    <template v-if="$page.props.auth.user">
                        <Link :href="route('snail::levels.edit', level)" v-if="$page.props.auth.user.id == level.creator_id" class="ml-4 px-4 py-2 text-sm text-white bg-blue-400 shadow rounded">Edit Level</Link>
                    </template>
                </div>
            </div>
            <div class="mt-4 bg-white dark:bg-gray-800 overflow-hidden shadow sm:rounded-lg">
                <div class="p-6 pt-4">
                    <span class="text-sm text-gray-500 ">Uploaded by <Link :href="route('snail::users.show', level.creator.id)" class="underline">{{ level.creator.name }}</Link> on <span v-text="this.innerText = new Date(this.level.created_at.split('T')[0]).toLocaleDateString('en-US', {year: 'numeric', month: 'long', day: 'numeric' })"></span></span>
                    <div class="mt-2 text-gray-800 dark:text-gray-400">
                        {{ level.description }}
                    </div>
                </div>
            </div>
    </app-layout>
</template>
<script>
import AppLayout from '@/Layouts/Snail'
import {Head as DocumentHead, Link} from '@inertiajs/inertia-vue3';
import BreezeDropdown from "@/Components/Dropdown";
import BreezeDropdownLink from "@/Components/DropdownLink";

export default {
    components: {
        AppLayout,
        DocumentHead,
        Link,
        BreezeDropdown,
        BreezeDropdownLink,
    },
    props: {
        auth: Object,
        level: Object,
    },

    methods: {
        highlight(e, copy = false) {
            let selection = window.getSelection();
            let range = document.createRange();
            range.selectNodeContents(e);
            selection.removeAllRanges();
            selection.addRange(range);
            if (copy) {
                navigator.clipboard.writeText();
            }
        }
    }
}
</script>
<style>
/* https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/ */
.grow-wrap {
    display: grid;
}
.grow-wrap::after {
    content: attr(data-replicated-value) " ";
    white-space: pre-wrap;
    visibility: hidden;
}
.grow-wrap > textarea {
    resize: none;
    overflow: hidden;
}
.grow-wrap > textarea,
.grow-wrap::after {
    border: transparent;
    border-radius: 5px;
    background: #F3F4F6;
    padding: 0.5rem;
    color: #6B7280;
    grid-area: 1 / 1 / 2 / 2;
}
</style>
